<template>
	<div class="sky-components-btn">
		<!-- 内容展示 -->
		<div v-if="unit" class="unit">
			{{ unit }}
		</div>
		<div class="content" v-show="trigger">
			{{ value }}
		</div>
		<!-- 动态组件 -->
		<el-input
			:value="value"
			v-show="!trigger"
			size="mini"
			@change="change"
			@input="input"
			@blur="blur"
		></el-input>
		<!-- 操作 -->
		<div class="btn showBtn hideBtn" @click="btnCLick" v-show="trigger && showUpdate">
			<ig-icon name="bianji1"></ig-icon>
		</div>
	</div>
</template>

<script>
export default {
	props: ['scope', 'tableData'],
	data() {
		let that = this;
		return {
			value: that.scope.row[that.tableData.bind],
			trigger: true,
		};
	},
	watch: {
		'scope.row': {
			handler(val) {
				this.value = val[this.tableData.bind];
			},
			deep: true,
		},
	},
	computed: {
		unit() {
			let { tableData } = this;
			let { unit } = tableData;
			if (!unit) return false;
			if (typeof unit == 'boolean') return unit;
			if (typeof unit == 'function') return unit(this.scope.row);
		},
		showUpdate() {
			let { scope, tableData } = this;
			if (tableData.showUpdate) {
				return tableData.showUpdate(scope.row);
			} else {
				return true;
			}
		},
	},
	methods: {
		btnCLick() {
			this.trigger = false;
		},
		change(val) {
			// if (!val) return false;
			let { scope, tableData } = this;
			this.trigger = true;
			if (tableData.change) {
				tableData.change(val, scope.row);
			}
		},
		input(val) {
			// if (!val) return false;
			// eslint-disable-next-line no-useless-escape
			val = val.replace(/[^\.\d]/g, '');
			val = val.replace('.', '');
			this.value = val;
		},
		blur() {
			this.trigger = true;
		},
	},
	components: {},
};
</script>

<style lang="scss" scoped>
.sky-components-btn {
	display: flex;
	align-items: center;
	user-select: none;

	.unit {
		margin-right: 5px;
	}

	.content {
		flex: 1;
		/* 单行溢出 */
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.btn {
		margin-left: 10px;
	}

	.hideBtn {
		display: none;
	}

	&:hover {
		.showBtn {
			display: block;
		}
	}
}
</style>
